import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {NgxPermissionsModule} from 'ngx-permissions';

import {Adapters} from './adapters';
import {AuthService} from './auth.service';
import { EncryptionService } from './encryption.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, NgxPermissionsModule.forChild(), HttpClientModule],
  providers: [AuthService,EncryptionService, ...Adapters],
})
export class AuthModule {}
